export default __webpack_public_path__ + "static/media/connect.a8434c96.png";